import React from 'react';
import { pricingPlans } from './pricingData';
import { PricingCard } from './PricingCard';
import styles from './Pricing.module.scss';

export const Pricing: React.FC = () => {
    return (
        <>
            <div className={styles.header}>
                <span className={styles.subtitle}>Стоимость обработки</span>
                <h2 className={styles.title}>
                    <span className={styles.gradientText}>Инвестиция</span>, которая окупается с<br />
                    первого бронирования или продажи
                </h2>
            </div>

            <div className={styles.grid}>
                {pricingPlans.map((plan) => (
                    <PricingCard key={plan.id} plan={plan} />
                ))}
            </div>
        </>
    );
};